export enum ReflectionScopeEnum {
  FLOW = 'flow',
  STEP = 'step',
  FORM = 'form',
}
